import React, { useState, useEffect } from 'react';

export default function CounterUp({isRunning}) {
    const [seconds, setSeconds] = useState(0);
    const [minutes, setMinutes] = useState(0);
  
    useEffect(() => {
      let intervalId;
      if (isRunning) {
        intervalId = setInterval(() => {
          if (seconds === 59) {
            setSeconds(0);
            setMinutes(minutes => minutes + 1);
          } else {
            setSeconds(seconds => seconds + 1);
          }
        }, 1000);
      }
  
      return () => clearInterval(intervalId);
    }, [seconds, isRunning]);
  
    return (
      <div style={{color: 'white'}}>
        {minutes.toString().padStart(2, '0')}:{seconds.toString().padStart(2, '0')}
      </div>
    );
}

